// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-paading {
  padding-left: 0;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.text-align-center {
  text-align: center;
}

.underline-h1 {
  text-decoration: underline;
}

.bold {
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/SearchOps/searchRuleEngine/addSearchRule.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".no-paading {\n  padding-left: 0;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.underline-h1 {\n  text-decoration: underline;\n}\n\n.bold {\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
